<template>
  <div class="checkbox-collapse-container">
    <el-input
      v-model="search"
      :placeholder="$t('搜索')"
      clearable
      class="mb-1 w-100"
      @input="handleSearch"
      @keyup.enter.native="handleSearch"
      @clear="handleSearch"
    >
      <el-button
        slot="append"
        style="padding-left: 0;"
        icon="el-icon-search"
        @click="handleSearch"
      />
    </el-input>

    <div class="d-flex justify-between">
      <el-checkbox
        v-model="checkAll"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >{{ $t('全选') }}</el-checkbox>

      <el-link style="vertical-align: baseline;" :underline="false" @click="isExpandAll = !isExpandAll">
        {{ isExpandAll ? $t('全部收起') : $t('全部展开') }}
        <i class="el-icon-arrow-down" :class="{'is-reverse': isExpandAll}"></i>
      </el-link>
    </div>

    <div style="height: 93%">
      <el-scrollbar style="height: 100%">
        <el-collapse v-if="datas.length" :value="isExpandAll ? datas.map((v, i) => i) : []">
          <el-collapse-item
            v-for="(collapseItem, collapseIndex) in datas"
            :key="collapseIndex"
            :name="collapseIndex"
            :title="collapseItem.name"
          >
            <!-- <template slot="title">
            {{ collapseItem.name }}
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{collapseItem.name}}</el-checkbox>
          </template> -->
            <el-checkbox
              v-for="item in collapseItem.children"
              :key="item.id"
              v-model="checkedList"
              :label="item.id"
              :disabled="item.disabled"
              @change="onChangeCheck(item)"
            >
              <span
                class="iconfont icon-dot font-xs"
                style="margin-right: 3px;"
                :style="{color: deviceStatusMap[item.runStatus || 'null'].barColor}"
              ></span>
              <span>{{ item.name }}</span>
            </el-checkbox>
          </el-collapse-item>
        </el-collapse>
        <el-empty v-else />
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { DEVICE_STATUS_MAP } from '@klinx/ccs/src/config/device/common';

export default {
  name: 'CheckboxCollapse',
  components: { },
  props: {
    datas: {
      type: Array,
      default() { []; }
    },
    defaultCheckedList: {
      type: Array,
      default() { []; }
    }
  },
  data() {
    return {
      deviceStatusMap: DEVICE_STATUS_MAP,
      search: '',
      checkAll: false,
      isExpandAll: true,
      // checkedList: [],
      isIndeterminate: false
    };
  },
  computed: {
    checkedList: {
      get() {
        return this.defaultCheckedList;
      },
      set(val) {
        this.$emit('update:defaultCheckedList', val);
      }
    }
  },
  watch: {
    checkedList(val) {
      this.handleCheckedChange();
    }
  },
  methods: {
    // 全选
    handleCheckAllChange(val) {
      this.checkedList = val ? this.treeToList(this.datas).map(v => v.id) : [];
      this.isIndeterminate = false;
    },
    treeToList(tree, result = []) {
      tree.forEach(node => {
        !node.children && !node.disabled && result.push(node);
        node.children && this.treeToList(node.children, result);
      });
      return result;
    },
    handleCheckedChange() {
      this.checkAll = this.checkedList.length === this.treeToList(this.datas).length;
      this.isIndeterminate = this.checkedList.length > 0 && this.checkedList.length < this.treeToList(this.datas).length;
    },
    handleSearch() {
      this.$emit('search', this.search);
    },
    onChangeCheck(e) {
      this.$emit('onChangeCheck', e);
    }
  }
};
</script>

<style lang='scss' scoped>
.el-icon-arrow-down{
  transition: transform .3s;
  transform: rotateZ(-90deg);
  &.is-reverse{
    transform: rotateZ(0deg);
  }
}

::v-deep .el-collapse{
  border: none;
  &-item{
    border: 1px solid #F2F2F2;
    margin: 10px 0;
    &__header{
      background: #F2F2F2;
      height: 30px;
      line-height: 30px;
      padding-left: 16px;
    }
    &__wrap{
      border-bottom: none;
    }
    &__content{
      padding: 16px;
    }
  }
}

::v-deep .el-checkbox__label{
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: text-bottom;
}

.checkbox-collapse-container{
  height: 100%;
}
</style>
